import { type Account, AccountSchema } from "../api/AccountSchema.ts";

export function readDuneRaider() {
  const raw = document.cookie
    .split("; ")
    .find((x) => x.startsWith("dune-raider="))
    ?.split("=")[1];
  if (!raw) return undefined;

  const decoded = decodeURIComponent(raw); // zurück zu JSON-String
  const parsed = JSON.parse(decoded);
  const account: Account = AccountSchema.parse(parsed);
  return account;
}
